import React, { useState } from 'react';
import { COLORS } from '../utils/constants.js';
import Spinner from '../components/Spinner.jsx';

export default function Prospect({ profile, addNotification, ai }) {
  const [search, setSearch] = useState({ titles: '', locations: '', seniorities: '', keywords: '' });
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const fields = [
    { key: 'titles', label: 'Job Titles', placeholder: 'e.g. CTO, VP Engineering' },
    { key: 'locations', label: 'Locations', placeholder: 'e.g. San Francisco, CA' },
    { key: 'seniorities', label: 'Seniorities', placeholder: 'e.g. director, vp, c_suite' },
    { key: 'keywords', label: 'Keywords', placeholder: 'e.g. SaaS, cloud' },
  ];

  return (
    <div>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4 }}>
        <span style={{ color: COLORS.blue }}>⊕</span> Prospect Finder
      </h2>
      <p style={{ color: COLORS.textMuted, fontSize: 13, marginBottom: 20 }}>Search Apollo's database for new leads. Uses credits.</p>

      <div style={{ padding: 20, borderRadius: 12, background: COLORS.surface, border: `1px solid ${COLORS.border}`, marginBottom: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
          {fields.map((f) => (
            <div key={f.key}>
              <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: COLORS.textDim, marginBottom: 4, textTransform: 'uppercase', letterSpacing: 1 }}>{f.label}</label>
              <input value={search[f.key]} onChange={(e) => setSearch((p) => ({ ...p, [f.key]: e.target.value }))} placeholder={f.placeholder} style={{ width: '100%', padding: '10px 12px', borderRadius: 8, border: `1px solid ${COLORS.border}`, background: COLORS.surfaceAlt, color: COLORS.text, fontSize: 13 }} />
            </div>
          ))}
        </div>
        <button onClick={() => addNotification('Search executes via Apollo MCP — use chat to run apollo_mixed_people_api_search', 'info')} style={{ marginTop: 16, padding: '10px 24px', borderRadius: 8, border: 'none', background: `linear-gradient(135deg, ${COLORS.blue}, ${COLORS.blueDim})`, color: '#fff', fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
          {loading ? <Spinner size={14} color="#fff" /> : 'Search Prospects'}
        </button>
        <span style={{ marginLeft: 12, fontSize: 11, color: COLORS.textDim }}>⚡ {profile?.credits || 0} credits remaining</span>
      </div>

      <div style={{ padding: 48, textAlign: 'center', borderRadius: 12, background: COLORS.surface, border: `1px dashed ${COLORS.border}` }}>
        <p style={{ fontSize: 40, margin: 0 }}>🔍</p>
        <p style={{ color: COLORS.textMuted, fontSize: 14, margin: '12px 0 0' }}>Enter search criteria and click "Search Prospects" to find leads.</p>
      </div>
    </div>
  );
}
